module.exports = __webpack_public_path__ + "static/banner3dgensprinter-d7eb79826f6e3944f46af2b009d37338.png";